import { MaxBetMessageCommand } from "slotworks/commands/betbar/max-bet-message-command";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import BetModel from "slotworks/model/bets/bet-model";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class MaxBetButtonControl extends AbstractButtonControl implements Control {

    private maxStake: number;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.button.on(ButtonEvent.CLICK, this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        this.maxStake = options.getMaxStake();

        super.updateOptions(options);

        if (BetModel.freeBet) {
            this.button.setEnabled(false);
        } else {
            this.button.setEnabled(this.enabled);
        }
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        // Never enable stepper during free bets
        if (BetModel.freeBet) {
            this.button.setEnabled(false);
        }
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.creditSizes = this.options.creditSizes.clone();
        options.selectedLines = this.options.selectedLines;
        options.creditsPerLine = this.options.creditsPerLine.clone();
        options.fixedBetCost = this.options.fixedBetCost;

        options.setTotalStake(this.maxStake);

        MaxBetMessageCommand(this.maxStake);

        this.onChange.dispatch(options);
    }
}
